import React from 'react';
import AppSidebar from '../AppSidebar';
import { Navbar } from '../Components/Catalyst/navbar';
import { SidebarLayout } from '../Components/Catalyst/sidebar-layout';
import { Heading, Subheading } from '../Components/Catalyst/heading';
import { Divider } from '../Components/Catalyst/divider';
import NotificationList from './NotificationList';
import LoadingSpinner from '../LoadingSpinner';
import { useMember } from '../Hooks/MemberContext';

interface NotificationPageProps {
  currentPage: string; // Keep this prop as it's needed for sidebar navigation
}

const NotificationPage: React.FC<NotificationPageProps> = ({ currentPage }) => {
  // The list is scoped by the caller's token on the server, so there is
  // no member id to pass down. This only waits so the sidebar has a name
  // to render.
  const { loading } = useMember();
  if (loading) {
    return <LoadingSpinner></LoadingSpinner>;
  }

  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={currentPage} />}
      navbar={<Navbar>{/* Your navbar content */}</Navbar>}
    >
      {/* Your page content */}
      <Heading>All Notifications</Heading>
      <Subheading>Stay updated with your latest notifications</Subheading>

      <Divider className="mt-4 mb-6"></Divider>

      <NotificationList></NotificationList>
    </SidebarLayout>
  );
};

export default NotificationPage;
